import { render, staticRenderFns } from "./AccettazioneSsnEditViewComponent.vue?vue&type=template&id=b05eb8d2&scoped=true"
import script from "./AccettazioneSsnEditViewComponent.vue?vue&type=script&lang=js"
export * from "./AccettazioneSsnEditViewComponent.vue?vue&type=script&lang=js"
import style0 from "./AccettazioneSsnEditViewComponent.vue?vue&type=style&index=0&id=b05eb8d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b05eb8d2",
  null
  
)

export default component.exports